import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { MaintenanceResult } from '../../pages/maintenance/enums/maintenance-result.enum';

@Pipe({
  name: 'maintenanceResult',
  standalone: true,
})
export class MaintenanceResultPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(maintenanceResult?: MaintenanceResult): string {
    switch (maintenanceResult) {
      case MaintenanceResult.OK:
        return this.translate('modules.maintenance.maintenanceResult.ok');
      case MaintenanceResult.OK_WITH_RESTRICTIONS:
        return this.translate('modules.maintenance.maintenanceResult.okWithRestrictions');
      case MaintenanceResult.NOT_OK:
        return this.translate('modules.maintenance.maintenanceResult.notOk');
      default:
        return this.translate('modules.maintenance.maintenanceResult.noResultAvailable');
    }
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
